export default {
  ljw: {
    profile: '李竞伟，港珠澳大桥管理局香港方副局长。',
  },
  yqh: {
    profile: '源秋华，港珠澳大桥管理局澳门方副局长。',
  },
  zyl: {
    profile: '朱永灵，男，湖南人。2010年7月，朱永灵被选为港珠澳大桥管理局局长，全面负责大桥主体工程的建设、运营和维护管理工作。2018年12月31日起，任港珠澳大桥管理局党委书记。',
    achievement: '从港珠澳大桥前期工作协调小组办公室主任到港珠澳大桥管理局局长，朱永灵用了14年的时间专注干港珠澳大桥建设一件事。这14年，他积极协调沟通三方，持续紧抓工程建设管理，提出并贯彻一系列科学先进建设理念，通过科技创新和重大设备、装备的研发，全力推进了工程建设。',
    personalReflections: '14年的付出终于有了结果，在全程主持和筹划超级工程的建设后，今天作为建设者、管理者代表站在这里，感到十分自豪。我们无愧于这个伟大的时代，无愧于奋斗的人生，心里充满着作为奋斗者的自豪。',
  },
  lm: {
    video: '/video/Interviews/lm.mp4',
    profile: '林鸣，教授级高级工程师，中共党员。2005底年开始参与工程前期准备，带领中国交建项目团队成功建设完成我国第一条外海沉管隧道。获“全国优秀共产党员”、“全国五一劳动奖章”、“全国劳动模范”、“央企楷模、“中央企业优秀共产党员标兵”、“感动交通十大年度人物”，享国务院特殊津贴。',
    achievement: '港珠澳大桥的标志性人物，他主持建设的岛隧工程是港珠澳大桥难度最大的部分。这是我国建设的第一条外海沉管隧道，也是世界上规模最大的公路沉管隧道和唯一的深埋沉管隧道，设计施工均无成熟经验可以借鉴。他以一种“强国筑梦”的责任感，义无反顾地率领团队承担起攀登世界建桥技术高峰的重任，践行着一位共产党员的崇高使命。在E15管节三次浮运两次返航的情况下依然不降低对接精度，为港珠澳大桥竖起了一根高质量的标杆。',
    personalReflections: '我们建设了一座让党和国家满意的大桥非常光荣，大桥也让我们实现了个人价值而无愧于此生。就个人而言，我是最幸运的工程师，我们最应感谢的是这个伟大的时代。',
  },
  sqk: {
    video: '/video/Interviews/sqk.mp4',
    profile: '苏权科，港珠澳大桥技术总负责人，主持港珠澳大桥主体工程方案研究、重大技术决策和融合三地的技术标准制定；创新品质规划、工业化建设理念，带领团队十四年辛勤耕耘，攻坚克难，在跨海通道建设领域，取得了国际领先的成套技术成果。',
    personalReflections: '对于行业来说，港珠澳大桥，更是一座科技之桥、品质之桥、文化之桥。全桥从头到尾，从上到下，科技创新无处不在；自始至终贯彻的高品质规划与细节追求，诠释了党的十九大提出的高质量发展战略；所展示的“珠联璧合”的景观文化理念，体现着粤港澳三地人民对祖国美好未来的期盼。',
  },
  mfc: {
    profile: '孟凡超，全国工程勘察设计大师，中国交建副总工程师，中交公路规划设计院有限公司副总经理。先后主持完成了港珠澳大桥可行性研究、主体工程初步设计及深水区桥梁施工图设计。',
    achievement: '面对来自香港、澳门和内地专家的多种不同意见，以及社会大众对港珠澳大桥不俗的期待，孟凡超他感受到更多的是责任和压力。“作为一项史无前例的超级桥梁工程，港珠澳大桥的设计要成为时尚的经典，既具有时代性，又不拘泥于时代性，才能经得住上百年的考验”。他全身心投入大桥设计工作，在手术后尚未脱离生命危险之时，仍然在与同事讨论设计问题。',
    personalReflections: '我作为一名港珠澳大桥的设计者，有幸从可行性研究、初步设计、施工图设计以及施工全过程参加大桥的建设，这是我职业生涯的新高度，我为能有机会向粤港澳大湾区奉献这样一项辉煌的设计作品而感到无比的自豪和光荣！',
  },
  zjw: {
    profile: '张劲文，提出项目愿景及建设目标，创新性策划并构建了主体工程管理模式，实施中推行严格履约下的合作伙伴关系，通过生产流程和工装设备的全面升级实现建设目标，负责工程策划、招标、质量、进度、交工验收、模拟运行等工作。',
    achievement: '1999年始一直从事大型基础设施工程管理实践。2004年起全程参与了港珠澳大桥前期立项和主体工程建设管理工作，提出了项目愿景及建设目标（建设世界级跨海通道、为用户提供优质服务、成为地标性建筑），策划并构建了项目管理规划及QHSE管理体系，创新了岛隧工程、桥梁工程、交通工程的项目管理模式，推行严格履约下的合作伙伴关系，创造性地提出并实践“工厂化、机械化、智能化、信息化”钢箱梁板单元全自动化生产线理念，通过生产流程和工装设备的全面升级实现产品升级，竭力将港珠澳大桥建成为新时代的标志性工程。',
    personalReflections: [
      '五千多个日夜，数万名建设者，成功将港珠澳大桥打造成新时代的标志性工程，向全世界诠释了中国智慧，彰显了“四个自信”。港珠澳大桥用铁的事实证明：在党中央和国务院的亲切关怀下，在中央部委和粤港澳三地政府的大力支持下，三地同心、远见卓识的管理制度，顶层设计和精益求精匠心独具的科研、设计、施工高度集成，是大桥攻坚克难取得决定性胜利的两大法宝。工程是干出来的，工程更是奋力用心干出来的。感谢所有建设者，感恩新时代赋予我们伟大的历史使命。大桥已成为高质量发展的典范，成为全球跨海通道新标杆。',
    ],
  },
  tgs: {
    profile: '谭国顺，已在桥梁建设的岗位上工作了47年。参加了数十座特大型桥梁的建设。其中包括东海大桥、杭州湾大桥、青岛海湾大桥、港珠澳大桥等大型工程。在建设单位的要求下，他花甲之年又率队参建港珠澳大桥，任CB05标项目经理。该标段优质高效地率先完成了所有任务，取得了无数个第一和创新的成果。多次得到管理局的表扬和嘉奖。',
    achievement: '谭国顺在年近花甲之年时参与港珠澳大桥建设，五年来，他身上那份特别能战斗，特别能吃苦，特别能创新，特别能奉献的精神，感染并影响了一批批年轻人，他以一名老党员的先锋形象，带动起整个团队，在超级工程的建设中迸发力量。在首个钢塔吊装出现异常情况时，果断处置，避免了一起桥毁人亡事故的发生。',
    personalReflections: '我必须为祖国的快速发展，继续不断地做出自己应有的贡献！看着我们的祖国真正成为世界上最强盛的国家！',
  },
  zq: {
    profile: '郑强，2003年毕业于武汉大学。2003年至今在中铁大桥勘测设计院集团有限公司工作，主要从事测绘技术研究与工程测量。2010年起参与港珠澳大桥建设，负责主体工程施工测量管理与技术服务工作，为港珠澳大桥建立了可靠地测量控制网。',
    achievement: '全面负责测量控制中心对项目测量基准维护、CORS系统运行及主体工程施工测量管理工作。面对项目跨海距离长、工程规模大、参建单位众多、海上环境特殊、工程结构复杂、建设要求及标准高等突出特点，具有针对性的组织开展基准维护、施工测量管理与协调、技术攻关及应用推广等工作。解决了粤港澳三地测量基准不一致的问题，完成了国内首个基于VRS技术的工程CORS系统建设及运行管理，实现了项目建设施工测量工作“零”失误，真正兑现了“世纪工程、测量先行”的承诺。',
    personalReflections: [
      '回首八年建设期，数万建设者投入港珠澳大桥的建设，每一位参建者都应深感骄傲和自豪。“圆梦桥、同心桥、自信桥、复兴桥”，此时的港珠澳大桥，已不仅是一座连接两岸三地的综合跨海交通工程，它更向世界展现了中国建设者无惧无畏、敢于挑战的新时代奋斗精神和气魄。',
      '中铁大桥院在港珠澳大桥中参与了勘察、设计、测控和岛隧监理工作，是这个时代给予了我们这么难得的机会，同样我们也不负时代重托。祝愿参与项目的建设者们在今后工作中再创佳绩，希望港珠澳大桥能更好地发挥两岸三地纽带作用，持续助力粤港澳大湾区繁荣！',
    ],
  },
  csz: {
    profile: '陈韶章，四十多年从事广州城轨交通工程规划、设计、施工管理及科研工作，是国内隧道知识最全面、实践经验最丰富的知名专家之一。2009年受聘为港珠澳大桥前期工作协调小组办公室首席隧道专家以来，全力推动项目沉管隧道的关键技术攻关，毅然投身于港珠澳大桥沉管隧道的建设，在举世瞩目的沉管隧道工程建设中起到了举足轻重的作用。',
    achievement: '已年逾古稀的沉管隧道专家陈韶章先生，谈起最熟悉的专业，仍然是声音抑扬顿挫，铿锵有力。言语中睿智又不乏幽默，严谨中透着宽容，令人印象深刻。23岁时从广东工学院（现广东工业大学）毕业之后，陈韶章的人生轨迹就与地铁工程建设结下不解之缘，从广州地铁起步到港珠澳大桥的顾问，长达48年的职业生涯中，他用实际行动来阐释何谓“人生在勤，不索何获”。',
    personalReflections: '我将再接再厉，为实现社会主义现代化强国贡献微薄的余热。',
  },
  cjf: {
    profile: '蔡俊福，教授级高工，2014年率队建设港珠澳大桥主体工程交通工程，带领团队发扬铁军精神，以把港珠澳大桥建设成为中国桥梁世纪丰碑为己任，攻克多项技术难题，圆满完成交通工程建设任务。',
    personalReflections: [
      '2018年10月23日，对我来说是一个永生难忘的日子，港珠澳大桥正式开通！这座承载着千千万万中国人梦想的超级大桥从梦想变为现实。',
      '港珠澳大桥，是粤港澳三地共同建设的超大型海上通道，回想起交通工程2014年上场至今，我们参加大桥施工的全体建设者，斗酷暑、战台风，夙兴夜寐，奋力拼搏，终于不辱使命，顺利完成了港珠澳大桥的建设任务。我本人和广大建设者一道，同甘共苦，共同奋斗，既有克服困难的艰辛，也有破解难题的喜悦，大家只有一个共同的信念：无论困难多大，一定要按时完成大桥的建设任务。今天，我们可以自豪地说，中国的建桥人是世界上最棒的。我们在各自的工作岗位上，做出了自己的贡献，也得到了党和人民的表彰，我们的团队获得了“全国五一劳动奖章”和“全国工人先锋号”等崇高荣誉，这是我个人的荣誉，更是企业的荣誉。',
      '我们在自己的工作岗位上，做出了自己应该做出的贡献，得到了祖国和人民至高的褒奖，我们为自己感到自豪。我们将重整行装再出发，到祖国最需要的地方去，为祖国的建设事业继续逢山开路遇水架桥，发扬铁军精神，为两个100年奋斗目标，为中华民族伟大复兴再立新功！',
    ],
  },
  ljh: {
    profile: '罗锦鸿，2012年6月底起参与港珠澳大桥建设，除主管党务工作外，同时分管综合后勤、人力资源和安全环保。港珠澳大桥主体工程建设过程中，以党建为主导，充分发挥党支部在施工项目上的战斗堡垒作用和党员的先锋模范作用，通过教育培训、“书记项目”、劳动竞赛等多种手段带动和鼓励参建员工积极投入工作。在艰苦卓绝的四年奋战中，不仅保持了员工队伍稳定，更不折不扣地为项目的生产经营建立了坚强的后盾，提供了周全的服务，激活了内生的动力，安全、优质、高效完成了CB04合同段的建设任务。主体工程完成后，继续留守大桥跟进收尾工作至今。',
    personalReflections: '作为交通建设行业中二十多年的从业者，在数以万计的港珠澳大桥建设者中，能被推选为建设者的党员代表，我倍感荣幸。',
  },
  xcy: {
    profile: '谢成远，他率领团队坚守7年，高标准完成CB05标桥梁工程的施工监理工作。面对复杂艰巨的建设目标，他率先提出并努力践行“技术服务质量安全”的理念，创新标段的统筹协调，圆满完成港珠澳大桥交工验收统筹工作。',
    achievement: [
      '谢成远同志率领的团队坚守了7年，他见证了桥梁工程在伶仃洋上从无到有、化茧成蝶的过程，桩基础、承台、桥墩、组合梁、钢塔等在海中组合延展，其中的推进过程总是在不断地考验着他与团队的智慧与耐力。',
      '2016年，谢成远同志带领团队根据收尾工程特点率先提出了狠抓工程外观质量、附属工程质量和细节管理，对已发现的不符合质量要求、外观拙劣的附属设施，要求坚决返工处理，杜绝以往工程固有“重内在质量、轻外观质量；重耐久性、轻附属工程质量”等弊病。2018年，谢成远带领的方舟监理团队圆满完成了港珠澳大桥全桥所有参建单位（施工、监理）交工验收统筹工作，为大桥顺利交工验收提供了可靠的基础支撑工作。',
    ],
    personalReflections: [
      '七年来，我和我的团队齐心协力，不畏困难，圆满完成合同工作，连续多次荣获集体及个人表彰和荣誉。',
      '从1998年湖北荆州长江大桥的施工监理开始，二十年来，我亲历了祖国交通建设监理事业的蓬勃发展，能参加港珠澳大桥这样的国家工程超级工程、与国内外的行业顶级团队合作，我的收获特别大，感恩祖国的强大和我们的新时代，能让我有这样难得的机遇。行业的发展是祖国发展的一个缩影，也是祖国繁荣的一部分，我将继续以质量安全无小事的警惕和慎重，沉下心踏实干，将监理的技术服务和咨询服务功能真正落实到每个项目上，为祖国的交通工程建设事业贡献我们的力量！',
    ],
  },
  mxl: {
    profile: '马学利，中共党员，电气高级技师，他热爱工作，具有很强的责任心和事业心，曾参与多座大桥的建设工作，并先后获得“集团公司优秀共产党员”、“青岛海湾大桥建设先进工作者”、“港珠澳大桥HSE综合管理优秀个人”、“中国中铁杰出青年岗位能手标兵”、“全国五一劳动奖章”、“中央企业技术能手”、“全国劳动模范”等荣誉称号。担负港珠澳大桥CB01标HSE管理期间，结合工程特点，不断完善项目部的HSE管理体系和管理制度，实现项目部的“零伤害、零事故、零污染”安全管理目标。',
    personalReflections: '在今后的工作中，我要将荣誉和压力变成工作的动力，激励我努力拼搏，继续前行。我们要继续做好百年山桥历史传承，充分发扬“追求卓越，勇于跨越”的中国中铁精神，认真学习宣传贯彻十九大报告精神，践行工匠精神与劳模精神，做到爱岗敬业、精益求精、开拓创新、争创一流。作为桥梁建设者，我们将重整行装再出发，撸起袖子加油干，积极投入国家的基础建设中去，再创辉煌，继续攀登新的高峰，为实现中华民族伟大的复兴梦贡献自己的一份力量。',
  },
  hcb: {
    profile: '胡昌炳对待港珠澳大桥岛隧工程监理技术一丝不苟，精益求精。他亲自编写了港珠澳大桥岛隧工程监理规划，非常具有实际意义。为了沉管隧道安装准确，他组建了水下检测组，使用先进的多波束测量仪、泥浆密度仪、GPS等先进的测量检测仪器，进行水下摄像与探摸，为港珠澳大桥做出了突出贡献。',
    achievement: '负责港珠澳大桥岛隧工程施工监理及港珠澳大桥主体工程的监理总体统筹工作。面临世界上综合难度最大的沉管隧道工程，胡昌炳自2010年11月进场至2018年3月止，始终坚守在施工现场，历时7年4个月，没有节假日，承受着巨大工作压力，胡昌炳常说，“只有睡在工地，心里才踏实”，在首个管节安装时，他在岛上坚守了4天5夜，直到管节安装成功，才返回总营地。胡昌炳全程参与了港珠澳大桥岛隧工程复杂技术问题及风险的处理，并在这些问题处理中，较好地发挥了监理的作用，在安装最终接头时，4天4夜，不眠不休，坚守在施工船舶上，针对最终接头首次安装出现的偏差，胡昌炳站在工程监理角度，和业主、承包人一起共同确定了最终接头进行重新安装调整的方案，为港珠澳大桥岛隧工程划上了圆满的句号，认真履行了监理职责。',
    personalReflections: '港珠澳大桥是党的十九大以来第一个建成通车的超大型跨海交通工程，我们为大桥岛隧工程抛洒了辛勤的汗水，凝聚着大桥监理的心血。这里是大桥监理的新起点。我们一定要不忘初心、牢记使命、努力进取，开拓创新，不断续写中国交通事业辉煌的新篇章。',
  },
  fjh: {
    profile: '樊建华，中共党员。2011年起参与工程建设，创新提出并推行“五个结合”特色党建理念，筹划组织完成了大型劳动竞赛、项目文化建设、工会活动等诸多工作，为长达八年奋斗历程的建设团队提供了坚实的保障，凝聚了一支打不散的团队。',
    personalReflections: '能为国家强大、为超级工程作贡献，付出再大都值得。',
  },
  jxx: {
    profile: '江晓霞，工学女博士，自2004年加入港珠澳大桥项目以来，她一直坚守在工程一线，全程参与了项目的前期规划、工程现场实施、及营运筹建工作。以其认真负责、爱岗敬业的良好的职业操守赢得同事的赞誉。',
    achievement: '先后任计划合同部副部长，营运管理部部长。港珠澳大桥超级工程的建设，对这位工学女博士有着深深的吸引。自2004年加入港珠澳大桥项目以来，她一直坚守在工程一线，全程参与了项目的前期规划、工程现场实施、及营运筹建工作。以其认真负责、爱岗敬业的良好的职业操守赢得同事的赞誉。',
    personalReflections: [
      '首先，我感到非常的骄傲与自豪：作为一名路桥专业工程师，十几年的职业生涯能够与港珠澳大桥紧密联系在一起，见证这项伟大的工程由构想成为现实，并最终成为行业的标杆，这让我感到无比的骄傲与自豪。',
      '其次，回想工程建设过程中十几年的风风雨雨，上千建设者共同努力，排除万难，为同一个理想和目标坚守多年，这是非常不容易的。这期间也有过争执与困惑，有过低迷和沮丧，但始终有一种信心让大家坚持至今。',
      '现在，项目建成通车了，并且得到了行业及社会上的高度肯定及认同，所有曾经付出的努力与执着，实在是太值了。',
    ],
  },
  sq: {
    profile: '施强同志带领项目团队常驻现场进行港珠澳大桥主体工程交通工程施工图设计工作，克服各种困难，按计划完成施工图设计各阶段任务，并与各参建单位以及有关部门进行了高强度协调工作。在整个施工期间，施强一直驻扎现场配合，亲自解决现场各种复杂问题，为工程的顺利开通扫清了障碍。',
    achievement: '七年如一日常驻港珠澳大桥设计项目部现场工作，始终把工作岗位赋予的使命置于首位，带领项目部成员按建设需要完成设计任务，同时完成与各有关参建单位及有关部门高强度协调工作。整个施工期间，亲自驻现场解决各种复杂问题，为工程的顺利开通扫清了障碍。',
    personalReflections: [
      '2018年10月23日这一天是个激动人心的日子，因为我们所参加设计的港珠澳大桥举行了盛大的开通仪式。',
      '七年多来坚守现场，为了港珠澳大桥建设而付出所有的牺牲和工作上的种种压力与艰辛都是值得的、有价值的！也让我更加满怀信心，坚信自己的人生选择，为祖国做出新的贡献！',
    ],
  },
  cll: {
    profile: '陈礼黎，中共党员，2002年入职中交一航局，硕士，高级政工师，港珠澳大桥首批建设者，扎根工地8年，历任工区党支部书记，全程参与多个标段建设和关键节点，曾获全国交通运输系统优秀思想政治工作者。',
    personalReflections: '回顾我的参建历程，不禁心潮澎湃、感慨万千：我作为首批参建者于2009年参加了大桥开工仪式，十年之后的今天又有幸参加了通车仪式，亲历了开工与开通，其中有8年奋战在大桥施工一线。8年的风风雨雨，见证了港珠澳大桥在茫茫伶仃洋上从无到有，一步一步傲然屹立，见证了我们这个伟大的时代、伟大的工程，见证了大国崛起。在港珠澳大桥八年的坚守与执着，换来了今天如此之高的回报，我感到此生有幸、此生有荣、此生无憾！',
  },
  gya: {
    profile: '管延安，中共党员，中交港珠澳大桥岛隧工程Ⅴ工区项目经理部机修班班长，大国工匠。2013年参与工程建设，负责沉管二次舾装等设备的安装，因其精湛的操作技艺被誉为中国“深海钳工”第一人。',
    personalReflections: [
      '2018年10月23日，对我来说是生命中最振奋人心的一天！我一辈子都不会忘记！我奋斗了七年的港珠澳大桥终于通车了，更是非常荣幸能够亲眼见证这一时刻。',
      '我是一名农民工出身，很荣幸能够参与港珠澳大桥这项超级工程的建设，我的家人都为我感到骄傲和自豪。在建设期间，我成长了很多，收获了很多，自己的价值也在港珠澳大桥有了更大的体现。我将重整行装再出发，继续攀登新的高峰。我一定用我所学建设更多的超级工程、世纪工程，为我们中华民族伟大复兴的中国梦贡献自己的力量。',
    ],
  },
  zbl: {
    video: '/video/Interviews/zbl.mp4',
    profile: '张宝兰 教授级高工，中共党员，2011－2017年担任中交港珠澳大桥岛隧工程沉管预制厂试验室主任，创造沉管预制百万方混凝土浇筑无裂缝的工程奇迹。荣获广东省五一劳动奖、五一巾帼奖、集体一等功、个人一等功、中交三大工程“建设功臣”等奖，获得2018年度珠海市敬业模范奖。',
    personalReflections: [
      '我是中国交建四航局的一名员工，把20多年的研究所得应用到沉管隧道预制混凝土上了，带领团队保质保量地完成了任务。在今后的工作中，坚持“道路自信、理论自信、制度自信、文化自信”，重整行装再出发，到祖国最需要的地方去，继续攀登新的高峰，体现人生的价值。我为自己感到自豪！为祖国的复兴贡献力量！',
      '往日的坚守与拼搏历历在目，今日，他们将重整行装，带着逐梦的初心，再启航！',
    ],
  },
}
